/* * @Author: zysQd  * @Date: 2021-04-25 11:13:33  * @Last Modified by:   zysQd  * @Last Modified time: 2021-04-25 11:13:33  */
import { getTechService, getTechServiceStat, createTechService, updateTechService, getTechServiceById, techServiceVerify, assignTechPerson } from '@/api/technicalService'
import Vue from 'vue'

const state = {
  techServices: [],
  techServicesStat: [],
  totalCounts: 0,
  statTotalCounts: 0,
}

const actions = {
  async getTechnicalServiceAction({ commit }, payload) {
    try {
      const res = await getTechService(payload)
      commit('SETTECHSERVICELIST', res.data)
      return res.data.techServiceList
    } catch (error) {
      throw error
    }
  },
  async getTechServiceStatction({ commit }, payload) {
    try {
      const res = await getTechServiceStat(payload)
      commit('SET_TECHSERVICE_STAT_LIST', res.data)
      return res.data.techServiceList
    } catch (error) {
      throw error
    }
  },
  async createTechServiceAction({ commit }, payload) {
    try {
      const newTechService = await createTechService(payload);
      commit('ADDNEWTECHSERVICE', newTechService.data)
    } catch (error) {
      throw error.message
    }
  },
  async updateTechServiceAction({ commit }, payload) {
    try {
      const newTechService = await updateTechService(payload.id, payload.data);
      commit('UPDATE_TECHNICAL', newTechService.data)
      return newTechService.data
    } catch (error) {
      throw error
    }
  },
  async assignTechPersonAction({ commit }, payload) {
    try {
      const newTechService = await assignTechPerson(payload.id, payload.data);
      commit('UPDATE_TECHNICAL', newTechService.data)
      return newTechService.data
    } catch (error) {
      throw error
    }
  },
  async getTechServiceByIdAction({ commit }, payload) {
    try {
      const currentTechService = await getTechServiceById(payload.id, payload.data);
      return currentTechService.data
    } catch (error) {
      throw error
    }
  },
  async techServiceVerifyAction({ commit }, payload) {
    try {
      const newTechService = await techServiceVerify(payload.id, payload.data);
      commit('UPDATE_TECHNICAL', newTechService.data)
      return newTechService.data
    } catch (error) {
      throw error
    }
  },
}

const mutations = {
  SETTECHSERVICELIST(state, payload) {
    state.techServices = payload.techServiceList
    state.totalCounts = payload.totalCounts
  },
  SET_TECHSERVICE_STAT_LIST(state, payload) {
    state.techServicesStat = payload
    state.statTotalCounts = payload.statTotalCounts
  },
  ADDNEWTECHSERVICE(state, techService){
    state.techServices.unshift(techService)
    state.totalCounts++
  },
  UPDATE_TECHNICAL(state, techService) {
    Vue.set(state.techServices, state.techServices.findIndex(x => x._id === techService._id), techService);
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}